"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = minifyStyles;

var _csso = _interopRequireDefault(require("csso"));

function minifyStyles(css) {
  return _csso["default"].minify(css).css;
}
//# sourceMappingURL=minifyStyles.js.map